module.exports = "<tab-login></tab-login>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/component/login/loginIndex.html
// module id = 184
// module chunks = 0